import { render, staticRenderFns } from "./preparation.vue?vue&type=template&id=22dc3a05&lang=html&"
import script from "./preparation.vue?vue&type=script&lang=js&"
export * from "./preparation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports